import { Injectable } from '@angular/core';
import { KeRefButtonItem } from '@selfai-platform/pipeline-common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KeRefButtonItemsService extends BehaviorSubject<KeRefButtonItem[]> {
  constructor() {
    super([]);
  }
}
